'use es6';

import http from 'hub-http/clients/apiClient';
import { BASE_URI_PROGRESS } from '../constants/ApiConstants';
const PROGRESS_TRANSFER_API_URL = `${BASE_URI_PROGRESS}/user-swaps`;
export function postProgressTransferRequest(newUserEmail) {
  return http.post(`${PROGRESS_TRANSFER_API_URL}/swap-by-email`, {
    data: {
      newUserEmail
    }
  });
}
export function verifyTransferProgress(confirmationGuid) {
  return http.post(`${PROGRESS_TRANSFER_API_URL}/confirm-request`, {
    timeout: 14000,
    data: {
      confirmationGuid
    }
  });
}